import CollectionHeader from "./collection-header";

export default CollectionHeader;